<template>
  <header class="header content-container">
    <div class="header-content">
      <div class="mobile">
        <div class="icon-container icon-container--left">
          <i class="material-icons" v-b-toggle.sidebar>menu</i>
        </div>
      </div>

      <div class="left-container">
        <img
          src="../../assets/images/gyra_banner/hyh_logo.png"
          alt="Gyra Banner"
          class="gyra-banner"
          @click="onBannerClick()"
        />
      </div>

      <div class="middle-container" v-if="showBottom">
        <div class="nav-bar">
          <div
            class="cat-nav"
            @mouseenter="setDropdown(true)"
            @mouseleave="setDropdown(false)"
          >
            <a
              class="nav"
              v-for="(navItem, index) in getNavItems"
              :key="index"
              @click="
                onNavClicked(navItem);
                setDropdown(false);
              "
              @mouseover="
                getSubNavItemsForNavItem(navItem);
                hoverNavItem(navItem);
              "
              :class="{
                'nav--selected': isHoveredNav(navItem)
              }"
            >
              {{ `header.${navItem.name}` | translate | capitalize }}
            </a>
            <div class="drop-down">
              <div
                class="dropdown"
                v-if="isDropdown && hoveredNavItemHasSubNavItem"
              >
                <div class="group-container">
                  <div class="category-group">
                    <h3>{{ "header.categories" | translate }}</h3>
                    <div class="group-matrix">
                      <div
                        v-for="(subNavItem, i) of subNavItems"
                        class="subNavItem"
                        :class="{
                          'subNavItem--selected': isSelectedSubNav(subNavItem)
                        }"
                        :key="i"
                        @click="onSubNavClicked(subNavItem)"
                      >
                        <div>
                          {{ getTranslation(subNavItem) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-container">
        <div class="search-box-container">
          <search-bar
            class="search-box"
            v-model="searchTerm"
            :placeholder="'header.search' | translate"
            @input="onSearchTermChanged()"
          />
        </div>
        <div class="locate-button flex" @click="onCartClick">
          <i class="material-icons">shopping_cart</i>
        </div>
        <!-- 
        <div class="locate-button flex" @click="onLocateClick">
          <p>{{ "header.map" | translate }}</p>
        </div> 
        -->
        <div class="flex" @click="onWishlistClick">
          <i class="material-icons">favorite</i>
        </div>
        <div v-if="hasUser" class="flex" @click="onAccountClick">
          <!--<p>{{ "header.account" | translate }}</p>-->
          <i class="material-icons">person</i>
        </div>
        <div v-else class="flex" @click="onLoginClick">
          <!--<p>{{ "header.login" | translate }}</p>-->
          <i class="material-icons">person</i>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import SearchBar from "../atoms/search-bar";
import {
  categoryNavigation,
  errorHandling,
  sexNavigation,
  userMixin
} from "../../mixins";
import { getPossibleFilterValues, getSample } from "../../services/api";
import { mapMutations } from "vuex";
import { productTypeNavigation } from "../../mixins/navigation/productTypeNavigation";
export default {
  name: "the-header",
  components: { SearchBar },
  mixins: [
    sexNavigation,
    categoryNavigation,
    errorHandling,
    productTypeNavigation,
    userMixin
  ],
  data() {
    return {
      searchTerm: null,
      isDropdown: false,
      subNavItems: [],
      hoveredNavItem: null
    };
  },
  methods: {
    onBannerClick() {
      this.$router.push({ name: "Home" });
    },
    onNavClicked(navItem) {
      this.resetProducts();
      this.resetFilters();
      this.setSubNavItemWithFilter(null);
      this.navigateToCategory(navItem);
    },
    onSubNavClicked(subNavItem) {
      this.resetProducts();
      this.setSubNavItemWithFilter(subNavItem);
      this.navigateToCategory(this.hoveredNavItem);
    },
    onSearchTermChanged() {
      // noop
    },
    onLocateClick() {
      this.resetFilters();
      this.getSample();
      this.$router.push({ name: "ProductMap" });
    },
    onCartClick() {
      this.resetFilters();
      this.$router.push({ name: "CartPage" });
    },
    onWishlistClick() {
      this.resetFilters();
      this.$router.push({ name: "WishlistPage" });
    },
    onAccountClick() {
      this.$router.push({ name: "Profile" });
    },
    onLoginClick() {
      const currentPath = this.$router.currentRoute.path;
      this.$router.push({ name: "Login", query: { returnPath: currentPath } });
    },
    async getSample() {
      const response = await getSample();
      if (response.status === 200) {
        this.setProducts(response.data);
      } else {
        this.handleHttpError(response);
      }
    },
    setDropdown(bool) {
      if (this.isDropdown !== bool) this.isDropdown = bool;
    },
    async getSubNavItemsForNavItem(navItem) {
      // todo: since only categories have subnavs now this can be simplified
      if (!navItem.hasSubNav) return null;
      this.subNavItems = [];
      let response = null;
      const value = navItem.name;
      switch (value) {
        case "ladies":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            category: value
          });
          break;
        case "shoes":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            category: value
          });
          break;
        case "accessories":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            category: "accessories"
          });
          break;
        case "sale":
          response = await getPossibleFilterValues("type", {
            sex: this.getSelectedSex(),
            onSale: true
          });
          break;
        // case "brands":
        //   response = await getPossibleFilterValues("brand", {
        //     sex: this.getSelectedSex()
        //   });
        //   break;
        // case "stores":
        //   response = await getPossibleFilterValues("store", {
        //     sex: this.getSelectedSex()
        //   });
        //   break;
      }
      if (response && response.status === 200) {
        this.subNavItems = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    isHoveredNav(navItem) {
      return navItem === this.hoveredNavItem;
    },
    hoverNavItem(navItem) {
      this.hoveredNavItem = navItem;
    },
    getTranslationCategory() {
      if (
        this.hoveredNavItem.name === "clothing" ||
        this.hoveredNavItem.name === "shoes" ||
        this.hoveredNavItem.name === "accessories" ||
        this.hoveredNavItem.name === "sale"
      )
        return "type";
      if (this.hoveredNavItem.name === "stores") return "store";
    },
    shouldBeTranslated() {
      return (
        this.hoveredNavItem.name === "clothing" ||
        this.hoveredNavItem.name === "shoes" ||
        this.hoveredNavItem.name === "accessories" ||
        this.hoveredNavItem.name === "sale" ||
        this.hoveredNavItem.name === "stores"
      );
    },
    getTranslation(subNavItem) {
      return this.shouldBeTranslated()
        ? this.$options.filters.capitalize(
            this.$options.filters.translate(
              `filter.${this.getTranslationCategory()}.${subNavItem}`
            )
          )
        : subNavItem;
    },
    isSelectedSubNav(subNavItem) {
      return subNavItem === this.getSubNavItem;
    },
    ...mapMutations({
      setSubNavItem: "navigation/setCurrentSubNavItem",
      resetProducts: "overview/reset",
      resetFilters: "filters/reset",
      setProducts: "overview/setProducts"
    })
  },
  computed: {
    hoveredNavItemHasSubNavItem() {
      return !this.hoveredNavItem || this.hoveredNavItem.hasSubNav;
    },
    showBottom() {
      return !(this.$route.meta.header && this.$route.meta.header.noBottom);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.header {
  position: relative;
  z-index: -1;

  &::after {
    content: "";
    border-bottom: 2px solid #f5f5f5;
    width: 100vw;
    height: 2px;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
  }
}

.header-content {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 0;

  .gyra-banner {
    width: 5rem;
    cursor: pointer;

    @media (min-width: $breakpoint-lg) {
      width: 7rem;
    }
  }

  .search-box-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .right-container {
    display: flex;
    align-items: center;

    .material-icons {
      margin-left: 0.25rem;
    }

    @media (min-width: $breakpoint-lg) {
      .material-icons {
        margin-left: 0.75rem;
      }
    }
  }
}

.middle-container {
  display: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 68.5px;
  width: 100%;

  @media (min-width: $breakpoint-lg) {
    display: flex;
  }

  .nav-bar {
    display: flex;
    flex-direction: row;

    justify-content: center;
    align-items: center;

    height: 100%;
  }
  .nav {
    font-weight: bold;
    position: relative;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 30px;
      @media (min-width: 1134px) {
        margin-right: 42px;
      }
    }
  }
  .nav--selected {
    &::after {
      content: "";
      position: absolute;
      bottom: -5px;
      width: 100%;
      border-bottom: 2px solid $gyra-salmon;
    }
  }
  .cat-nav {
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;
  }
}

.dropdown {
  min-height: 50vh;
  width: 100vw;
  background-color: white;
  z-index: -1;
  position: absolute;
  top: 189px;
  left: 0;

  -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  .group-container {
    position: relative;
    display: flex;
    flex-direction: row;
    padding-top: 46px;

    h3 {
      margin-bottom: 18px;
    }

    .category-group {
      flex: 2;
      margin-left: 156px;
    }

    .group-matrix {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .subNavItem {
        margin-right: 83px;
        display: flex;
        /*flex: 0 0 15%;*/
        width: 150px;
        @media (min-width: $gyra-breakpoint-xl) {
          width: 200px;
        }
        cursor: pointer;
      }

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
          text-decoration: underline;
        }
      }

      .subNavItem--selected {
        p {
          font-weight: 700;
          text-decoration: underline;
        }
      }
    }

    .sustainable-group {
      flex: 1;
      margin-left: 150px;
    }

    .brand-group {
      flex: 1;
      margin-left: 150px;
    }
  }
}

.drop-down-enter-active,
.drop-down-leave-active {
  transition: transform 0.4s ease-in-out;
}

.drop-down-enter,
.drop-down-leave-to {
  transform: translateY(-1200px);
}

.mobile {
  display: flex;
  @media (min-width: $breakpoint-lg) {
    display: none !important;
  }
}

.icon-container {
  @media (min-width: $breakpoint-lg) {
    display: none;
  }
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hidden {
  visibility: hidden;
}

.flex {
  display: flex;
}
</style>
